"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWrapper = exports.MediaUploader = exports.ControlsWrapper = exports.ControlButtonIcon = exports.ControlButton = exports.CircularProgressBar = exports.CancelButton = exports.AddPictureIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _CircularProgressBar = _interopRequireDefault(require("../CircularProgressBar"));
var _palette = require("../../styles/palette");
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MediaUploader = exports.MediaUploader = _styledComponents["default"].div.attrs(function (p) {
  return {
    style: {
      backgroundImage: p.readyState === 'DONE' ? "url('".concat(p.backgroundURL, "')") : 'none',
      cursor: p.readyState === _constants.READY_STATE.EMPTY ? 'pointer' : 'auto',
      minHeight: p.isDesktop ? 200 : 174
    }
  };
}).withConfig({
  displayName: "styles__MediaUploader",
  componentId: "sc-e1jkn6-0"
})(["background-color:", ";background-position:50% 50%;background-repeat:no-repeat;background-size:cover;border-radius:3px;padding:", ";position:relative;height:200px;&:focus{outline:0;}"], _palette.commonPalette.gray, function (p) {
  return p.isImage ? '52px 36px 34px' : '0';
});
var TextWrapper = exports.TextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__TextWrapper",
  componentId: "sc-e1jkn6-1"
})(["color:#646464;font-size:12px;line-height:1.33;text-align:center;"]);
var ControlsWrapper = exports.ControlsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ControlsWrapper",
  componentId: "sc-e1jkn6-2"
})(["position:absolute;display:flex;flex-direction:column;top:16px;right:16px;"]);
var CircularProgressBar = exports.CircularProgressBar = (0, _styledComponents["default"])(_CircularProgressBar["default"]).withConfig({
  displayName: "styles__CircularProgressBar",
  componentId: "sc-e1jkn6-3"
})(["display:block;margin:0 auto 8px;"]);
var AddPictureIcon = exports.AddPictureIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'multimedia',
  size: 26
}).withConfig({
  displayName: "styles__AddPictureIcon",
  componentId: "sc-e1jkn6-4"
})(["color:#757575;display:block;margin:10px auto 15px;"]);
var CancelButton = exports.CancelButton = _styledComponents["default"].button.attrs({
  type: 'button'
}).withConfig({
  displayName: "styles__CancelButton",
  componentId: "sc-e1jkn6-5"
})(["background:none;border:0;color:inherit;cursor:pointer;display:block;font:inherit;margin:16px auto 0;padding:0;text-decoration:underline;&:focus{outline:0;}"]);
var ControlButton = exports.ControlButton = _styledComponents["default"].button.attrs({
  type: 'button'
}).withConfig({
  displayName: "styles__ControlButton",
  componentId: "sc-e1jkn6-6"
})(["background:", ";border:0;border-radius:3px;cursor:pointer;display:block;padding:8px;&:focus{outline:0;}+ ", "{margin-top:8px;}"], _palette.commonPalette.gray, function () {
  return ControlButton;
});
var ControlButtonIcon = exports.ControlButtonIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  size: 24
}).withConfig({
  displayName: "styles__ControlButtonIcon",
  componentId: "sc-e1jkn6-7"
})(["color:#323232;display:block;"]);
//# sourceMappingURL=styles.js.map